import React from 'react';

// Importing all sections used in the homepage
import { Home, About, Counter, Testimonials, Blogs, Services, NewsletterSection, Features, Team, Banner, Calculator, WhyChooseUs, ProjectSection, Clients, Process, Pricing } from '../../sections';



const HomePage = () => {

  return (
    <div className='homepage'>
      <Home /> {/* Home Section */}
      <Features /> {/* Features Section */}
      <About /> {/* About Section */}
      <Counter /> {/* Counter Section */}
      <Services /> {/* Services Slider */}
      <WhyChooseUs /> {/* Why Choose Us section */}
      <Process /> {/* Process section */}
      <Banner /> {/* Banner Section */}
      <ProjectSection /> {/* Project Section */}
      <Testimonials /> {/* Testimonials Slider */}
      <Team /> {/* Team section */}
      <Calculator /> {/* Cost Calculator */}
      <Pricing /> {/* Pricing section */}
      <NewsletterSection /> {/* Newsletter subscription Section */}
      <Blogs /> {/* Latest blog posts */}
      <Clients /> {/* Clients Slider */}
    </div>
  )

}

export default HomePage;